import { setRootAdminUiState } from '../../app/actions/spaces/RootAdminUiStateActions';
import { getAppStore } from '../../app/AppStore';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { UserErrorCode } from '../helpers/ErrorCodes';
import { Module } from '../Module';
import { PasswordPolicyScope, PasswordPolicyService } from '../services/PasswordPolicyService';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { Location } from '../../common/react/Location';

export interface IInitializationFormModelScope {
  username: string;
  password: string;
  confirmPassword: string;
  displayName: string;
}

export interface IInitializationScope extends PasswordPolicyScope {
  maybeInitialize: () => void;
  isActiveDirectory: () => boolean;
  isLocal: () => boolean;
  passwordFieldsAreNonEmpty: () => boolean;
  initializationForm: ng.IFormController;
  formData: IInitializationFormModelScope;
  result: string;
  busy: boolean;
  errorMessageKey: string;
}

export class InitializationCtrl {

  public static $inject = [
    '$scope',
    '$location',
    'PasswordPolicyService'
  ];

  constructor(
    $scope: IInitializationScope,
    $location: ng.ILocationService,
    passwordPolicyService: PasswordPolicyService
  ) {
    const server = getSessionManagementServiceInstance();
    $scope.formData = {
      username: '',
      password: '',
      confirmPassword: '',
      displayName: ''
    };
    $scope.isActiveDirectory = () => ServerSettingsUnauthenticated.isServerDomainFamilyActiveDirectory();
    $scope.isLocal = () => ServerSettingsUnauthenticated.isServerDomainFamilyLocal();

    $scope.passwordFieldsAreNonEmpty = () => {
      return !$scope.isActiveDirectory() &&
        $scope.formData.password &&
        $scope.formData.confirmPassword &&
        $scope.formData.password.length > 0 &&
        $scope.formData.confirmPassword.length > 0;
    };

    const respectsPasswordValidation =
      passwordPolicyService.loadPoliciesIntoScope($scope, () => $scope.formData.password, () => {});

    $scope.maybeInitialize = () => {
      if ($scope.initializationForm.$valid && respectsPasswordValidation()) {
        $scope.busy = true;
        server.initialize($scope.formData.username, $scope.formData.password, $scope.formData.displayName)
          .then(() => {
            getAppStore().dispatch(setRootAdminUiState('default'));
            $scope.result = 'success';
            const urls = new SpacesSiteUrls({siteUrlName: ''});
            Location.instance.setHash(urls.projectsPath());
          })
          .catch((errorCode: number) => {
            $scope.result = 'failure';
            $scope.busy = false;
            switch(errorCode) {
              case UserErrorCode.UserInsufficientLicenses:
                $scope.errorMessageKey = 'signInFailedUnlicensedServer';
                break;
              case UserErrorCode.UserPasswordNotRespectingPolicies:
                $scope.errorMessageKey = 'errorUserPasswordNotRespectingPolicies';
                break;
              default:
                $scope.errorMessageKey = 'initializationFailed';
                break;
            }
          });
      } else {
        $scope.result = 'invalidForm';
      }
    };

  }

}

Module.instance().controller('InitializationCtrl', InitializationCtrl);
